import React from 'react';
import { Document, BLOCKS } from '@contentful/rich-text-types';

import { WebBanner } from './index';

interface AppIncidentBannerProps {
  toggleBanner: (arg0: any) => void;
  roundedCornersVariation?: boolean;
}

export function AppIncidentBanner({
  toggleBanner,
  roundedCornersVariation
}: AppIncidentBannerProps) {
  const emptyMessage: Document = {
    nodeType: BLOCKS.DOCUMENT,
    data: {},
    content: [
      {
        nodeType: BLOCKS.PARAGRAPH,
        data: {},
        content: [
          {
            nodeType: 'text',
            value: ' ',
            marks: [],
            data: {}
          }
        ]
      }
    ]
  };

  return (
    <WebBanner
      title={
        'Our app is experiencing some issues. We’re working to resolve them as soon as possible.'
      }
      titleColor="#111212"
      message={emptyMessage}
      messageColor="#111212"
      bannerBackgroundColor="#ffe8bd"
      toggleBanner={toggleBanner}
      roundedCornersVariation={roundedCornersVariation}
    />
  );
}

export default AppIncidentBanner;
